import React, { useState, useRef, useEffect } from "react"
import { useHistory } from "react-router-dom"
import InfiniteScroll from "react-infinite-scroll-component"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { MdClose } from "react-icons/md"
import clsx from "clsx"

import { getShifts } from "services"
import { useClickOutside } from "hooks"
import { isInKioskMode } from "utils"
import { InfiniteScrollLoading, Navbar, Spinner } from "components"
import ShiftCashierHistoryCard from "./ShiftCashierHistoryCard"
import classes from "./ShiftCashierHistorySidebar.module.scss"

const limit = 20

const ShiftCashierHistorySidebar = (props) => {
  const {
    selectedShift,
    setSelectedShift,
    openShiftHistorySidebar,
    setOpenShiftHistorySidebar
  } = props

  const [t, i18n] = useTranslation()

  const { _id: accountId, branchId } =
    useSelector(state => state.userAccountInfo)

  const history = useHistory()

  const [shifts, setShifts] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [skip, setSkip] = useState(0)

  const loadingMore = useRef(false)
  const unmount = useRef(false)

  const handleGoBack = () => {
    if (isInKioskMode()) {
      history.push("/kiosk-settings")

      return
    }

    history.push(
      "/settings",
      { initialTab: "shiftCashier" }
    )
  }

  useClickOutside(() => {
    setOpenShiftHistorySidebar(false)
  }, [
    "shift-cashier-history-sidebar",
    "shift-cashier-hamburger-button"
  ])

  const handleLoadMore = async () => {
    if (!hasMore || loadingMore.current) return

    loadingMore.current = true

    try {
      const response =
        await getShifts({
          limit,
          skip,
          accountId,
          branchId
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setShifts(prev => [...prev, ...response])
    } catch (err) {
      console.log(err)
    }

    loadingMore.current = false
  }

  const getShiftHistory = async () => {
    try {
      const response =
        await getShifts({
          limit,
          skip: 0,
          accountId,
          branchId
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setShifts(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    getShiftHistory()
  }, [])

  useEffect(() => {
    return () => unmount.current = true
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      id="shift-cashier-history-sidebar"
      className={clsx(
        classes["sidebar"],
        isLtr && classes["sidebar-ltr"],
        openShiftHistorySidebar && classes["open"],
        openShiftHistorySidebar && isLtr && classes["sidebar-ltr"]
      )}
    >
      <Navbar
        title={t("شیفت_های_قبلی")}
        hideLeftIconInMobileView
        onLeftIconPress={handleGoBack}
        rightSideComponent={() =>
          <button
            className={classes["close"]}
            onClick={() => setOpenShiftHistorySidebar(false)}
          >
            <MdClose
              color="white"
              size={25}
            />
          </button>
        }
      />
      {shifts !== null
        ?
        shifts.length > 0
          ?
          <div
            id="scrollable-div"
            className={classes["list"]}
          >
            <InfiniteScroll
              hasMore={hasMore}
              dataLength={skip}
              next={handleLoadMore}
              style={{ overflow: "hidden" }}
              loader={<InfiniteScrollLoading />}
              scrollThreshold="100px"
              scrollableTarget="scrollable-div"
            >
              {shifts.map(shift =>
                <ShiftCashierHistoryCard
                  key={shift._id}
                  shift={shift}
                  selectedShift={selectedShift}
                  setSelectedShift={setSelectedShift}
                />
              )}
            </InfiniteScroll>
          </div>
          :
          <div className={classes["centered"]}>
            {t("شیفتی_پیدا_نشد")}
          </div>
        :
        <div className={classes["centered"]}>
          <Spinner
            color="var(--color-primary)"
            size={25}
          />
        </div>
      }
    </div>

  )
}

export default ShiftCashierHistorySidebar